const NAMESPACE = "communicationContent";

const KEYS = {
    contentEmptyValidationErrorMessage: "contentEmptyValidationErrorMessage"
};

const MESSAGES = {
    [KEYS.contentEmptyValidationErrorMessage]: {
        value: "Please specify content.",
        comment:
            "Validation error message that appears if the user has no visible text content in the body of the communication"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
